import { types, actions } from './requests'
export const GETWORKORDERLIST_TYPES = {
    ...types('GETWORKORDERLIST'),
}
export const GETWORKORDERLIST_ACTIONS = {
    ...actions('GETWORKORDERLIST'),
}